<template>
	<main class="main">
	    <div class="container-fluid px-0">
	        <div class="container">
	            <div class="row flex-center min-vh-100 py-5">
	                <div class="col-sm-10 col-md-8 col-lg-5 col-xl-5 col-xxl-3">
	                	<form v-on:submit.prevent="submitForm">
		                    <div class="text-center mb-7">
		                        <h3 class="text-1000">Log In</h3>
		                    </div>
		                    <div class="mb-3 text-start">
		                        <label class="form-label" for="email">Email</label>
		                        <div class="form-icon-container">
		                        	<input
		                        		v-model="data.email"
	                                    @input="errors.email = null"
	                                    :class="{'is-invalid': errors.email}"
		                        		class="form-control form-icon-input" 
		                        		type="text" 
		                        		placeholder="admin@admin.com" />
		                        	<span class="fa-regular fa-user text-900 fs--1 form-icon"></span>
		                        	<div class="invalid-feedback">{{errors.email}}</div>
		                        </div>
		                    </div>
		                    <div class="mb-3 text-start">
		                        <label class="form-label" for="password">Password</label>
		                        <div class="form-icon-container">
		                        	<input
		                        		v-model="data.password"
                                        @input="errors.password = null"
                                        :class="{'is-invalid': errors.password}"
		                        		class="form-control form-icon-input" 
		                        		type="password" 
		                        		placeholder="Password" />
		                        	<span class="fa-regular fa-key text-900 fs--1 form-icon"></span>
		                        	<div class="invalid-feedback">{{errors.password}}</div>
		                        </div>
		                    </div>

		                    <div class="row flex-between-center mb-3">
							    <div class="col-auto">
							        <div class="form-check mb-0">
							        	<input class="form-check-input" id="basic-checkbox" type="checkbox" checked="checked" />
							        	<label class="form-check-label mb-0" for="basic-checkbox">Remember me</label>
							        </div>
							    </div>
							    <div class="col-auto">
							    	<router-link class="fs--1 fw-semi-bold" :to="{name: 'Register'}">Register</router-link>
							    </div>
							</div>
		                    
		                    <button class="btn btn-primary w-100 mb-3" type="submit">Sign In</button>
		                </form>
	                </div>
	            </div>
	        </div>
	    </div>
	</main>
</template>

<script>

export default {
	data () {
        return {
            data: {
                email: null,
                password: null
            },
            errors: {
                email: false,
                password: false
            }
        }
    },
    methods: {
        async submitForm () {
           	if(!this.data.email) {
                this.errors.email = 'The field is required'
                return
            }
            if(!this.data.password) {
                this.errors.password = 'The field is required'
                return
            }
            
            this.$axios.post('/auth/login', JSON.stringify(this.data))
            .then((response) => {
                response = response.data
                switch (response.status) {
                    case "error":
                        break
                    case "success":

                    	localStorage.setItem('token', response.token)
                            
                        this.$axios.defaults.headers.common.Authorization = 'Bearer ' + response.token

                        this.setUser(response.user)
                        
                        this.$router.push({name: 'CampaignsItems'})
                        break
                    default:
                        this.$toast.error('Unknown error')
                }
            }).catch((error) => {
            	if(error.response.status == 409) {
            		this.$router.push({name: 'CampaignsItems'})
            		return
            	}

            	let response = error.response.data
            	if('status' in response && response.status == 'error') {
            		if('field' in response) {
            			this.errors[response.field] = response.message
            		}

            		this.$toast.error(response.message)
            	}
            })
        }
    }
}
</script>